import { render, staticRenderFns } from "./Lostfound.vue?vue&type=template&id=ae119faa&scoped=true"
import script from "./Lostfound.vue?vue&type=script&lang=js"
export * from "./Lostfound.vue?vue&type=script&lang=js"
import style0 from "./Lostfound.vue?vue&type=style&index=0&id=ae119faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae119faa",
  null
  
)

export default component.exports